export default __webpack_public_path__ + "static/media/LoginBackground.5c09eece.png";